import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import Button from 'flarum/common/components/Button';
import DiscussionControls from 'flarum/forum/utils/DiscussionControls';
import ResetDiscussionViewsModal from './ResetDiscussionViewsModal';
export default function () {
  extend(DiscussionControls, 'moderationControls', function (items, discussion) {
    if (discussion.canReset()) {
      items.add('reset', m(Button, {
        icon: "far fa-eye",
        onclick: () => app.modal.show(ResetDiscussionViewsModal, {
          discussion
        })
      }, app.translator.trans('fof-discussion-views.forum.discussion_controls.resetviews_button')), -10);
    }
  });
}